import {
    initialFeedState,
    FeedState,
} from 'mk2/apps/forum/containers/FeedUntrustworthyUser/FeedUntrustworthyUser.reducers';
import { PostEntity, PostSchema } from 'mk2/apps/forum/schemas';
import { memoizeOne } from 'mk2/helpers/cache';
import { AppState } from 'mk2/reducers';
import { CommentEntity } from 'mk2/schemas';
import { getDenormalizedEntities } from 'mk2/selectors';

export const getFeedUntrustworthyUserState = (state: AppState, username: string): FeedState =>
    state.containers.forum.forumFeedUntrustworthyUser &&
    state.containers.forum.forumFeedUntrustworthyUser[username] ||
    initialFeedState;

export const getFeedUntrustworthyUserPostsOfComments = memoizeOne((state: AppState, comments: CommentEntity[]): PostEntity[] => {
    const postIds: number[] = comments.map((c) => c.postId);
    return getDenormalizedEntities<PostEntity>(state, PostSchema, postIds);
});
